import { MapBoxConfig } from '../app/types'

export const setUpMapBox = (config: MapBoxConfig) => {
  console.info('mapBoxConfig: ', config)
}
